import { MaterialHeaderType, mapMaterialHeaderType } from "./MaterialHeaderType";
import { MaterialStructureType, mapMaterialStructureTypes } from "./MaterialStructureType";
import { MaterialUnitType, mapMaterialUnitType } from "./MaterialUnitType";

export interface MaterialDataType {
    id: number;
    material_data_id: number | null;
    item_name: string | null;
    unit_id: number | null;
    quantity: number | null;
    unit_price: number | null;
    sub_total: number | null;
    percentage: number | null;
    note: string | null;
    include_tax: 1 | 0;
    last_buying_price: number | null;
    order: MaterialStructureType[];
    delivered: MaterialStructureType[];
    onsite: MaterialStructureType[];
    header_data: MaterialHeaderType | null;
    unit: MaterialUnitType | null;
}

// to single object maping
export const mapMaterialDataType = (data: any): MaterialDataType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialDataType: MaterialDataType = {
        id: data.id,
        material_data_id: data.material_data_id || null,
        item_name: data.item_name || null,
        unit_id: data.unit_id || null,
        quantity: data.quantity || null,
        unit_price: data.unit_price || null,
        sub_total: data.sub_total || null,
        percentage: data.percentage || null,
        note: data.note || null,
        include_tax: data.include_tax,
        last_buying_price: data.last_buying_price || null,
        order: Array.isArray(data.order) ? mapMaterialStructureTypes(data.order) : [],
        delivered: Array.isArray(data.delivered) ? mapMaterialStructureTypes(data.delivered) : [],
        onsite: Array.isArray(data.onsite) ? mapMaterialStructureTypes(data.onsite) : [],
        header_data: data.header_data !== null ? mapMaterialHeaderType(data.header_data) : null,
        unit: data.unit !== null ? mapMaterialUnitType(data.unit) : null
    }

    return materialDataType;
}


// maping list objects
export const mapMaterialDataTypes = (data: any[]): MaterialDataType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapMaterialDataType);
}